<template>
    <div ref="refItem" class="item-container">
        <router-link
            class="item-label"
            :to="{ name: 'competence', params: { id: item.id }}"
            :title="item.name"
        >
            {{ item.name }}
        </router-link>
        <div class="item-content">
            <div class="item-progress">
            </div>
            <Flag
                class="flag"
                :style="flagPosition"
            />
            <Bullet
                class="bullet"
                :style="bulletPosition"
                :level="{ key: item.competenceLevel, value: bulletIndex }"
                :requiredLevel="{ key: item.requiredLevel, value: flagIndex }"
            />
            <div
                v-for="(level, index) in levels"
                :key="level.key"
                class="item-stripe"
                :style="getStripePosition(index)"
            ></div>
        </div>
    </div>
</template>

<script>
import Bullet from "./Bullet";
import Flag from "./Flag";
import { $helperGetLeftPosition } from "./helpers";

export default {
    name: "SoftCompetenceItem",

    components: {
        Bullet,
        Flag,
    },

    props: {
        item: {
            type: Object,
            default: () => {},
        },
        levels: {
            type: Array,
            default: () => [],
        },
        containerWidth: {
            type: Number,
            default: 0,
        },
    },

    computed: {
        flagIndex() {
            return this.levels.findIndex(el => el.key === this.item.requiredLevel );
        },

        bulletIndex() {
            return this.levels.findIndex(el => el.key === this.item.competenceLevel );
        },

        flagPosition() {
            return this.getLeftPosition(this.flagIndex);
        },

        bulletPosition() {
            return this.getLeftPosition(this.bulletIndex <= this.flagIndex ? this.bulletIndex : this.flagIndex);
        },
    },

    methods: {
        getStripePosition(index) {
            return this.getLeftPosition(index);
        },

        getLeftPosition(index) {
            return $helperGetLeftPosition({
                index,
                length: this.levels.length - 1,
                containerWidth: this.containerWidth,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';

.item {
    &-container {
        position: relative;
        width: 100%;
        height: 76px;
        padding: 0 20px;
        z-index: 1;

        @include on-xs {
            height: 92px;
            padding: 0 4px;
        }
    }

    &-label {
        display: inline-block;
        margin: 0 0 4px 0;
        font-weight: 600;
        font-size: 14px;
        line-height: 16px;
        color: #4663AB;
        z-index: 2;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        @include on-xs {
            margin: 1px 0 8px 0;
        }
    }

    &-progress {
        box-sizing: border-box;
        height: 40px;
        border: 1px solid #E6E9EE;
        border-radius: 36px;
        background: #F5F9FC;
        z-index: 1;
    }

    &-stripe {
        position: absolute;
        top: 0;
        width: 1px;
        height: 76px;
        background: #E3E9F0;
        z-index: -1;

        @include on-xs {
            height: 92px;
        }
    }
}
.bullet {
    position: absolute;
    top: 20px;
    transform: translate(-50%);

    @include on-xs {
        top: 30px;
    }
}

.flag {
    position: absolute;
    top: 28px;
    left: 98%;
    transform: translate(-50%);

    @include on-xs {
        top: 35px;
    }
}
</style>